import { css } from '@emotion/css';
import { colors } from 'constants/theme';
import deleteImg from 'assets/images/icons/delete.png';

const lotteryTypeInputStyles = {
    wrap: css``,
    pickBet: css``,
    pickRow: css`
        display: flex;
        align-items: center;
        padding: 8px 0;
    `,
    pickLeft: css`
        display: flex;
        align-items: center;
        flex: 1;

        p {
            flex: 0 0 70px;
            background: #d7e1ff;
            margin-right: 20px;
            padding: 3px 8px 5px;
            line-height: 1;
            border-radius: 10px 0 20px 0;
            color: ${colors.borderPrimary};
            font-weight: bold;
        }
    `,
    pickNum: css`
        display: flex;
        gap: 10px;
    `,
    numPickItem: css`
        width: 36px;
        height: 36px;
        border-radius: 36px;
        font-size: 24px;
        display: flex;
        align-items: center;
        justify-content: center;
        background: ${colors.white};
        border: 2px solid ${colors.borderPrimary};
        cursor: pointer;
        font-weight: 600;
        color: ${colors.borderPrimary};

        &.active {
            background: linear-gradient(to bottom, #1b53f0, #011e98);
            color: ${colors.white};
            color: ${colors.white};
        }
        &:hover {
            border-color: ${colors.primary};
        }
    `,
    pickRight: css`
        display: flex;
        gap: 6px;
    `,
    btnPickQick: css`
        font-size: 14px;
        padding: 4px 0;
        min-width: 48px;
        border: 1px solid ${colors.borderPrimary};
        border-radius: 6px;
        cursor: pointer;
        background: ${colors.white};
        font-weight: bold;
        color: ${colors.borderPrimary};
        &.active {
            background: ${colors.primary};
            color: ${colors.white};
        }
        &:last-child {
            color: transparent;
            background: url(${deleteImg}) no-repeat center center;
            background-size: contain;
            border: 0;
            min-width: 30px;
        }
    `,
};
export default lotteryTypeInputStyles;
